// UTM helper for the Naos landing page.
const UTM_PARAMS: Record<string, string> = {
  utm_source: "stack-wl",
  utm_medium: "stack-wl",
  utm_campaign: "stack-wl",
};

const KNOWN_PREFIXES = ["/fr-fr", "/en-us", "/es-es", "/nl-nl", "/de-de", "/it-it", "/pt-pt"];

export const withUtm = (href: string, _lang?: string): string => {
  if (!href) return href;
  if (!/^https?:\/\//i.test(href)) return href;
  try {
    const url = new URL(href);
    Object.entries(UTM_PARAMS).forEach(([k, v]) => {
      if (!url.searchParams.has(k)) {
        url.searchParams.set(k, v);
      }
    });

    if (url.hostname === "www.naboo.app") {
      const hasLocalePrefix = KNOWN_PREFIXES.some(
        (pre) => url.pathname === pre || url.pathname.startsWith(pre + "/")
      );
      if (!hasLocalePrefix) {
        // no prefix needed for FR
      }
    }

    return url.toString();
  } catch {
    return href;
  }
};
